import { BackToLoginLink, Rule } from 'components/core-v2'
import { Link } from 'react-router-dom'

import { COPY } from '../constants'
import { TwoColumnWithImage } from '../templates/TwoColumnWithImage'

interface MainElementProps {
  content: {
    email: string
    message: string
    title: string
    unlockAccount: string
  }
}

const MainElement = ({ content }: MainElementProps) => (
  <>
    <p>{content.message}</p>
    <p className="mb-0">{content.unlockAccount}</p>
    <Link to={`mailto:${content.email}`}>{content.email}</Link>
    <Rule className="my-12" />
    <BackToLoginLink />
  </>
)

interface AccountLockedProps {
  inactive?: boolean
}
export const AccountLocked = ({ inactive }: AccountLockedProps) => {
  const content = inactive ? COPY.accountInactive : COPY.accountLocked
  return (
    <TwoColumnWithImage mainElement={<MainElement content={content} />} title={content.title} />
  )
}
